import React, { useState } from 'react';
import './contact.css';
//for sending email directly into inbox
import emailjs from '@emailjs/browser';

function Contact() {
  const [fullname, setFullname] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [loader, setLoader] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    //const BASE_URL = 'https://siya-website-backend.herokuapp.com';
    //const BASE_URL = "http://localhost:5000"

    // const contact = {
    // 	fullname: fullname,
    // 	email: email,
    // 	phone: phone,
    // 	message: message,
    // };

    //using emailjs. this is the template to create for the code beloe
    const templateParams = {
      from_name: fullname,
      notes: message,
      message: message,
      reply_to: email,
      to_name: 'Marsiya Issah',
    };

    if (templateParams) {
      const myModal = document.getElementById('custom-modal');
      // myModal.style.display = 'block';
      const close = document.getElementById('close');
      close.addEventListener('click', () => {
        myModal.style.display = 'none';
      });

      // axios
      // 	.post(`${BASE_URL}/contact/add`, contact)
      // 	.then((response) => {
      // 		console.log(response.data);
      // 	})
      // 	.catch((error) => {
      // 		console.log(error);
      // 	});

      //emailjs config from website make the key open no env
      emailjs.send('service_vhe7uct', 'template_lkigcyi', templateParams, 'D3M9J610xqDSOkpCT').then(
        (response) => {
          console.log('SUCCESS!', response.status, response.text);
          setLoader(true);
          myModal.style.display = 'block';
          setFullname('');
          setEmail('');
          setPhone('');
          setMessage('');
          setLoader(false);
        },
        (err) => {
          console.log('FAILED...', err);
        }
      );
    }
  };

  return (
    <div className='contacts-container'>
      <div className='contact-jumbotron jumbotron jumbotron-fluid'></div>

      <div className='container position'>
        <h5 className='contact-title text-center'>
          Kindly leave a message and I will get back to you as soon as I can.
        </h5>

        <form onSubmit={onSubmit} name='contact' className='form'>
          <div className='right'>
            <input
              id='fullname'
              type='text'
              name='fullname'
              placeholder='Full Name'
              value={fullname}
              onChange={(e) => setFullname(e.target.value)}
              autoFocus
              required
            />
            <input
              id='email'
              type='email'
              name='email'
              placeholder='Email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input
              id='phone'
              type='tel'
              name='phone'
              placeholder='Phone Number - (optional)'
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          <div className='left'>
            <textarea
              id='message'
              type='text'
              name='message'
              placeholder='Message'
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows='5'
              columns='65'
              required
            />

            <input
              id='contact-btn'
              className='contact-me all-btn'
              type='submit'
              value={loader ? 'loading...' : 'Contact Me'}
            />
          </div>
        </form>
      </div>

      <div id='custom-modal'>
        <div className='newModal' id='myModal'>
          <div className='dialog'>
            <div className='modalContent'>
              <div className='myHeader'>
                <h5 className='modalTitle'>Message sent</h5>
              </div>
              <div className='modal-message'>Thanks for the message will get back to you soon, Cheers!!!</div>
              <div className='modalFooter'>
                <button type='button' id='close' className='btn btn-danger'>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
